<template>
  <div class="question_image">
    <img
      v-for="image in images"
      :key="image.ID"
      :src="image.url"
      :alt="image.alt"
    />
  </div>
  <ul class="question_choises">
    <li v-for="(item, index) in answers" :key="index">
      <InputRadioButton
        name="examMasterChoices"
        :id="`answer-${index}`"
        :label="item.answer"
        :value="String(index)"
        :currentValue="state.selectedIndex"
        @call-input-change="selectIndex"
      />
    </li>
  </ul>
  <div class="question_submit">
    <Button
      label="正解を確認する"
      primary
      :disabled="state.selectedIndex === null"
      :handleClick="submitAnswer"
    />
  </div>
</template>

<script lang="ts">
import InputRadioButton from '@/components/elements/InputRadioButton.vue'
import Button from '@/components/elements/Button.vue'
import { computed, reactive, SetupContext } from 'vue'
import { axiosSetting } from '@/utils/axiosSetting'

const axios = axiosSetting('app', 'action')
export default {
  name: 'MasterQuestion',
  props: {
    answers: Array,
    images: Array,
    questionId: Number,
    questionType: Number
  },
  emits: ['submit'],
  components: {
    Button,
    InputRadioButton
  },
  setup(props: any, context: SetupContext) {
    const state = reactive<any>({
      selectedIndex: null
    })
    const selectValue = computed(() => props.answers[state.selectedIndex])
    const submitAnswer = () => {
      context.emit('submit', selectValue.value)
      console.log({
        question_id: props.questionId,
        question_type: props.questionType,
        result: selectValue.value.right_flag,
        select_value: selectValue.value.answer
      })
      axios
        .post('/api/v1/dialogue_entry', {
          question_id: props.questionId,
          question_type: props.questionType,
          result: selectValue.value.right_flag,
          select_value: selectValue.value.answer
        })
        .then((res) => console.log(res))
        .catch((e) => console.log(e))
    }
    const selectIndex = (e: any) => {
      state.selectedIndex = e
    }
    return {
      state,
      selectIndex,
      submitAnswer
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.question_image {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0;
  gap: 20px;
  @include mixins.media() {
    margin: 50px 0;
  }
}
.question_choises {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  @include mixins.media() {
    grid-template-columns: 1fr 1fr;
    gap: 20px 35px;
  }
}

.question_submit {
  margin: 30px -16px 0;
  padding-top: 20px;
  padding-bottom: 20px;
  background: #f5f5f5;
  @include mixins.media() {
    background: none;
    margin: 30px 0 0;
  }
}

.question_result {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #e7f8f6;
  font-weight: bold;
  font-size: 2.2rem;
  color: var.$color-main-text;

  & + p {
    margin-top: 10px;
    font-size: 1.6rem;
  }
}

::v-deep(.question_choises) {
  .radioButton_label {
    height: auto;
    padding: 20px 15px;
  }

  .radioButton_label::after {
    top: 26px;
    left: 21px;
  }
}
</style>
